<p>Applying for a loan with us is easy and should only take you a few minutes. We'll have a decision for you, normally within
    one working day. </p>
<p>To complete your application, you’ll need details of the auction property to hand.</p>
<h5>Tell us about the property you want to buy</h5>
<form [formGroup]="tad_apply_form">
    <fieldset>
        <div class="row">
            <div class="col-12 col-lg-8">
                <div class="form-group c-radio--descriptive">
                    <span class="c-radio-button">
                        <input type="radio" formControlName="tad_apply_property_type" name="tad_apply_property_type" id="residentialLoan" value="0">
                        <label class="c-radio-button__label" for="residentialLoan">
                            <span class="c-radio-button__faux">Residential property</span>
                            <svg class="c-radio-button__faux-indicator icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 16 13">
                                <path fill="#f9b114" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z"
                                />
                            </svg>
                            <span class="c-radio-button__description">e.g. terrace, semi-detached, detached</span>
                        </label>
                    </span>
                </div>
                <div class="form-group c-radio--descriptive">
                    <span class="c-radio-button">
                        <input type="radio" formControlName="tad_apply_property_type" name="tad_apply_property_type" id="commercialLoan" value="1">
                        <label class="c-radio-button__label" for="commercialLoan">
                            <span class="c-radio-button__faux">Commercial property</span>
                            <svg class="c-radio-button__faux-indicator icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 16 13">
                                <path fill="#f9b114" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z"
                                />
                            </svg>
                            <span class="c-radio-button__description">e.g. office, industrial units</span>
                        </label>
                    </span>
                </div>
                <div class="form-group c-radio--descriptive">
                    <span class="c-radio-button">
                        <input type="radio" formControlName="tad_apply_property_type" name="tad_apply_property_type" id="semiCommercialLoan" value="2">
                        <label class="c-radio-button__label" for="semiCommercialLoan">
                            <span class="c-radio-button__faux">Semi commercial property</span>
                            <svg class="c-radio-button__faux-indicator icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 16 13">
                                <path fill="#f9b114" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z"
                                />
                            </svg>
                            <span class="c-radio-button__description">e.g. shop with flat</span>
                        </label>
                    </span>
                </div>
                <div class="form-group c-radio--descriptive">
                    <span class="c-radio-button">
                        <input type="radio" formControlName="tad_apply_property_type" name="tad_apply_property_type" id="landLoan" value="3">
                        <label class="c-radio-button__label" for="landLoan">
                            <span class="c-radio-button__faux">Land</span>
                            <svg class="c-radio-button__faux-indicator icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 16 13">
                                <path fill="#f9b114" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z"
                                />
                            </svg>
                        </label>
                    </span>
                </div>
            </div>
        </div>
        <together-auction-dip-stage-select [forward_disabled]="tad_apply_form.invalid" [backward_disabled]="disableBackward" [disabled]="_handleDisableButtons()"
            [show_action]="false" [show_forward]="true" [show_backward]="showPreApproval" [forward_title]="'Check your eligibility'"
            [backward_title]="'I\'d like pre-approval first'" (on_forward)="_handleForward()" (on_backward)="_handleBackward()"></together-auction-dip-stage-select>
        <together-auction-dip-loading [is_loading]="_isLoading"></together-auction-dip-loading>
    </fieldset>
</form>